import React, { Component, PropTypes } from 'react';
import { debounce } from 'lodash';
import CodeMirror from 'codemirror';

import CodeMirrowShowHint from 'codemirror/addon/hint/show-hint';
import CodeMirrowCssHint from 'codemirror/addon/hint/css-hint';
import CodeMirrowXmlHint from 'codemirror/addon/hint/xml-hint';
import CodeMirrowHtmlHint from 'codemirror/addon/hint/html-hint';
import CodeMirrowJavascriptHint from 'codemirror/addon/hint/javascript-hint';

import CodeMirrorXmlMode from 'codemirror/mode/xml/xml';
import CodeMirrorCssMode from 'codemirror/mode/css/css';
import CodeMirrorJavascriptMode from 'codemirror/mode/javascript/javascript';
import CodeMirrorMixedMode from 'codemirror/mode/htmlmixed/htmlmixed';

import CodeMirrorFoldCode from 'codemirror/addon/fold/foldcode';
import CodeMirrorFoldGutter from 'codemirror/addon/fold/foldgutter';
import CodeMirrorFoldXml from 'codemirror/addon/fold/xml-fold';

import CodeMirrorEditCloseBrackets from 'codemirror/addon/edit/closebrackets';
import CodeMirrorEditCloseTag from 'codemirror/addon/edit/closetag';
import CodeMirrorEditMatchBrackets from 'codemirror/addon/edit/matchbrackets';
import CodeMirrorEditMatchTags from 'codemirror/addon/edit/matchtags';

import CodeMirrorSelectionActiveLine from 'codemirror/addon/selection/active-line';

import './CodeEditor.scss';

import { SAVE_LEVEL } from '../../../constants/Level';
import { CATEGORIES, FileService } from '../../../services/fileUpload/uploadFile';

const EDITOR_PROFILES = {
    default: {
        editor: {
            mode: { name: 'htmlmixed' }
        }
    },
    javascript: {
        editor: {
            mode: { name: 'javascript', globalVars: true }
        }
    },
    css: {
        editor: {
            mode: { name: 'css' }
        }
    },
    html: {
        editor: {
            mode: { name: 'html' }
        }
    }
};

//prevent tree-shaking of plugin imports
const plugins = [
    CodeMirrowShowHint,
    CodeMirrowCssHint,
    CodeMirrowXmlHint,
    CodeMirrowHtmlHint,
    CodeMirrowJavascriptHint,
    CodeMirrorXmlMode,
    CodeMirrorCssMode,
    CodeMirrorJavascriptMode,
    CodeMirrorMixedMode,
    CodeMirrorFoldCode,
    CodeMirrorFoldGutter,
    CodeMirrorFoldXml,
    CodeMirrorEditCloseBrackets,
    CodeMirrorEditCloseTag,
    CodeMirrorEditMatchBrackets,
    CodeMirrorEditMatchTags,
    CodeMirrorSelectionActiveLine
];
const noop = () => {};
export class CodeEditor extends Component {
    static defaultProps = {
        defaultValue: '',
        disabled: false,
        onChange: noop,
        onMediaInsert: noop,
        mode: 'htmlmixed'
    };
    static propTypes = {
        defaultValue: PropTypes.string,
        mode: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
        onMediaInsert: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.textareaNode = null;
        this.cm = null;
        this.handleOnChange = debounce(this.handleOnChange.bind(this), 200);
    }
    handleOnChange() {
        this.props.onChange(this.cm.getValue());
    }
    componentDidMount() {
        if (this.textareaNode) {
            this.cm = CodeMirror.fromTextArea(this.textareaNode, {
                lineNumbers: true,
                extraKeys: {
                    'Ctrl-Space': 'autocomplete',
                    'Ctrl-Q': cm => {
                        cm.foldCode(cm.getCursor());
                    },
                    'Ctrl-J': 'toMatchingTag',
                    'Ctrl-M': cm => {
                        cm.refresh();
                    }
                    /*"Ctrl-I": (cm) => {
                        const cursor = cm.getCursor();
                        cm.replaceRange(this.props.onMediaInsert(), cursor, cursor);
                    }*/
                },
                matchTags: { bothTags: true },
                mode: { name: this.props.mode, globalVars: true },
                lineWrapping: true,
                foldGutter: true,
                readOnly: this.props.disabled,
                autoCloseTags: true,
                autoCloseBrackets: true,
                styleActiveLine: true,
                gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
                plugins: plugins
            });
            this.cm.on('change', this.handleOnChange);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.defaultValue !== this.props.defaultValue && this.cm) {
            this.cm.setValue(nextProps.defaultValue);
        }
        this.cm.setOption('readOnly', nextProps.disabled);
    }

    componentWillUnmount() {
        if (this.cm) {
            this.cm.toTextArea();
        }
    }

    render() {
        return (
            <textarea
                ref={node => (this.textareaNode = node)}
                defaultValue={this.props.defaultValue}
                disabled={this.props.disabled}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/CodeEditor/CodeEditor.js